/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Email_InvalidInputs */

const en_reset_email_invalid = /** @type {(inputs: Reset_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid email address.`)
};

/** @type {(inputs: Reset_Email_InvalidInputs) => LocalizedString} */
const ar_reset_email_invalid = en_reset_email_invalid;

/** @type {(inputs: Reset_Email_InvalidInputs) => LocalizedString} */
const he_reset_email_invalid = en_reset_email_invalid;

/** @type {(inputs: Reset_Email_InvalidInputs) => LocalizedString} */
const ur_reset_email_invalid = en_reset_email_invalid;

/** @type {(inputs: Reset_Email_InvalidInputs) => LocalizedString} */
const es_reset_email_invalid = en_reset_email_invalid;

/** @type {(inputs: Reset_Email_InvalidInputs) => LocalizedString} */
const fr_reset_email_invalid = en_reset_email_invalid;

/** @type {(inputs: Reset_Email_InvalidInputs) => LocalizedString} */
const de_reset_email_invalid = en_reset_email_invalid;

/** @type {(inputs: Reset_Email_InvalidInputs) => LocalizedString} */
const pt_reset_email_invalid = en_reset_email_invalid;

/** @type {(inputs: Reset_Email_InvalidInputs) => LocalizedString} */
const hi_reset_email_invalid = en_reset_email_invalid;

/** @type {(inputs: Reset_Email_InvalidInputs) => LocalizedString} */
const bn_reset_email_invalid = en_reset_email_invalid;

/**
* | output |
* | --- |
* | "Enter a valid email address." |
*
* @param {Reset_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const reset_email_invalid = /** @type {((inputs?: Reset_Email_InvalidInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Email_InvalidInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reset_email_invalid(inputs)
	if (locale === "he") return he_reset_email_invalid(inputs)
	if (locale === "ur") return ur_reset_email_invalid(inputs)
	if (locale === "es") return es_reset_email_invalid(inputs)
	if (locale === "fr") return fr_reset_email_invalid(inputs)
	if (locale === "de") return de_reset_email_invalid(inputs)
	if (locale === "pt") return pt_reset_email_invalid(inputs)
	if (locale === "hi") return hi_reset_email_invalid(inputs)
	if (locale === "bn") return bn_reset_email_invalid(inputs)
	return /** @type {LocalizedString} */ ("Enter a valid email address.")
});